import {a, div, img} from '@xh/hoist/cmp/layout';
import {hoistCmp, XH} from '@xh/hoist/core';
import './WelcomeMsg.scss';
import multiavatar from '@multiavatar/multiavatar';

export const welcomeMsg = hoistCmp.factory(() => {
    const user = XH.getUser(),
        avatar = multiavatar(user.displayName),
        className = 'rzx-welcome-message';

    return div({
        className,
        items: [
            div({
                className: `${className}__profile-pic`,
                item: img({src: `data:image/svg+xml;utf8,${encodeURIComponent(avatar)}`})
            }),
            div({
                items: [
                    div({className: `${className}__profile-pic__username`, item: user.displayName}),
                    a({className: `${className}__profile-pic__profile`, item: 'view profile'})
                ]
            })
        ]
    });
});
